import React from 'react';
import styles from './layout.module.scss';
import { classNames } from '../../utils';
export var AppWidth = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classNames([styles.appWidth, className]) }, children));
};
export var DocWidth = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement("div", { className: classNames([styles.docWidth, className]) }, children));
};
//# sourceMappingURL=layout.js.map